export default __webpack_public_path__ + "d84bd93aca3db3dfd699e65cabcf25de.woff";